<template>
  <div v-if="session" class="d-flex px-5 py-5" no-gutters>
    <div class="flex-shrink-1 px-2">
      <session-menu-container :value="session" />
    </div>
    <div class="flex-grow-1 px-2" style="overflow: hidden">
      <router-view style="width: 100%" :session.sync="session" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SessionMenuContainer from '../containers/SessionMenuContainer'

export default {
  name: 'SessionLayout',
  components: {
    SessionMenuContainer,
  },
  props: {
    sessionId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('me', {
      isAuthenticated: 'isAuthenticated',
    }),
    ...mapGetters('animation', {
      sessionList: 'sessionList',
      openedSessionIdList: 'openedSessionIdList',
      sessionLastRouteHistory: 'sessionLastRouteHistory',
    }),
    session: {
      get () {
        return this.sessionList
          .find(session => session.id === this.sessionId)
      },
      set (session) {
        this.patchSession(session)
      },
    },
    isSessionExist () {
      return this.openedSessionIdList.includes(this.sessionId)
    },
    hasNoChildRouteSpecified () {
      return this.$route.name === 'AnimationSession'
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.ensureSessionRouteIsValid()
      },
    },
    openedSessionIdList: {
      handler () {
        if (this.isAuthenticated) {
          this.ensureSessionRouteIsValid()
        }
      },
    },
  },
  beforeRouteUpdate (to, from, next) {
    this.updateLastRouteHistory()
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (this.isAuthenticated) {
      this.updateLastRouteHistory()
    }
    next()
  },
  methods: {
    ...mapActions('animation', {
      saveLastRouteHistory: 'saveLastRouteHistory',
      patchSession: 'patchSession',
    }),
    ensureSessionRouteIsValid () {
      if (!this.isSessionExist) {
        this.goToFallbackRoute()
      }
      // Open session without specified panel
      else if (this.hasNoChildRouteSpecified) {
        this.goToDefaultRoute()
      }
    },
    goToFallbackRoute () {
      if (this.openedSessionIdList.length) {
        const firstSessionId = this.openedSessionIdList[0]
        this.$router.replace(`/animation/session/${firstSessionId}`)
      }
      else {
        this.$router.replace('/animation')
      }
    },
    goToDefaultRoute () {
      if (this.sessionLastRouteHistory[this.sessionId]) {
        this.$router.replace(this.sessionLastRouteHistory[this.sessionId])
      }
      else {
        this.$router.replace(`/animation/session/${this.sessionId}/players`)
      }
    },
    updateLastRouteHistory () {
      if (this.isSessionExist && !this.hasNoChildRouteSpecified) {
        this.saveLastRouteHistory({
          sessionId: this.sessionId,
          path: this.$route.path,
        })
      }
    },
  },
}
</script>
